module.exports = __webpack_public_path__ + "static/media/content-su-kien-1.a28c2c1c.png";